export default __webpack_public_path__ + "static/media/logo-spotify.64b875da.svg";